var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-card',[_c('v-system-bar',[_vm._v("Kurs-Flipper")]),_c('v-card-text',[_c('Flipper',{attrs:{"value":_vm.course.students,"name":`course_flipper_${_vm.course.id}`}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }